import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { CandidateLinkShell } from '../components/CandidateLinkShell'
import { getTranslations, resolveLanguage } from '../services/translations'

/**
 * A public notice for bearer-link uploads. It deliberately needs no client
 * lookup: the code is never sent to a careers-page resolver or analytics.
 */
const CandidatePrivacyNotice: React.FC = () => {
  // The notice is opened without a lookup: the page that links here passes the
  // candidate's language, and the browser's is the fallback.
  const [params] = useSearchParams()
  const language = resolveLanguage(params.get('lang'), navigator.language)
  const tr = getTranslations(language)
  return (
    <CandidateLinkShell language={language}>
      <h1 className="text-2xl">{tr['candidate_link.privacy_title']}</h1>
      <p className="mt-4 text-base" style={{ color: 'var(--link-ink-soft)' }}>
        {tr['candidate_link.privacy_p1']}
      </p>
      <p className="mt-4 text-base" style={{ color: 'var(--link-ink-soft)' }}>
        {tr['candidate_link.privacy_p2']}
      </p>
    </CandidateLinkShell>
  )
}

export default CandidatePrivacyNotice
